import WorksRequest from "../ws/WorksRequest";

export const CONSTRUCTIONS_AUTOCOMPLETE_UPDATE = 'constructions-autocomplete-update';
export const CONSTRUCTIONS_AUTOCOMPLETE_LOADING = 'constructions-autocomplete-loading';

export const getConstructions = (search = '', date = null) => (dispatch) => {

  new WorksRequest(1, search, 0, false, date)
    .onPreExecution(() => {
      dispatch({
        type: CONSTRUCTIONS_AUTOCOMPLETE_LOADING,
        payload: true,
      });
    })
    .onSuccess(response => {
      // Enviamos los datos a redux
      dispatch({
        type: CONSTRUCTIONS_AUTOCOMPLETE_UPDATE,
        payload: response,
      });
    })
    .onPostExecution(() => {
      dispatch({
        type: CONSTRUCTIONS_AUTOCOMPLETE_LOADING,
        payload: false,
      });
    })
    .execute();
};



// WEBPACK FOOTER //
// ./src/app/works/actions/constructionsAutocompleteActions.js